import { render, staticRenderFns } from "./workload-details.vue?vue&type=template&id=20dc7314&scoped=true&"
import script from "./workload-details.vue?vue&type=script&lang=js&"
export * from "./workload-details.vue?vue&type=script&lang=js&"
import style0 from "./workload-details.vue?vue&type=style&index=0&id=20dc7314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc7314",
  null
  
)

export default component.exports